import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type initStateType = {
  mapLoaded: boolean;
  sideBarOpened: boolean;
  hideAllMenus: boolean;
  isChukkerEditedBannerVisible: boolean;
  dispatchSaveChukker: boolean;
  dispatchCancelChukker: boolean;
  tempLang: string | null;
};

const initialState: initStateType = {
  mapLoaded: true,
  sideBarOpened: false,
  isChukkerEditedBannerVisible: false,
  hideAllMenus: false,
  dispatchSaveChukker: false,
  dispatchCancelChukker: false,
  tempLang: null,
};
export const displayReducer = createSlice({
  name: "display",
  initialState,
  reducers: {
    updateMapState: (state, action: PayloadAction<boolean>) => {
      state.mapLoaded = action.payload;
    },
    toggleSideBar: (state, action: PayloadAction<boolean>) => {
      state.sideBarOpened = action.payload;
    },
    toggleHideMenu: (state, action: PayloadAction<boolean>) => {
      state.hideAllMenus = action.payload;
    },
    toggleIsChukkerEditedBannerVisible: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isChukkerEditedBannerVisible = action.payload;
    },
    toggleDispatchSaveChukker: (state, action: PayloadAction<boolean>) => {
      state.dispatchSaveChukker = action.payload;
    },
    toggleDispatchCancelChukker: (state, action: PayloadAction<boolean>) => {
      state.dispatchCancelChukker = action.payload;
    },
    setTempLang: (state, action: PayloadAction<string | null>) => {
      state.tempLang = action.payload;
    },
  },
});
export const {
  toggleDispatchSaveChukker,
  toggleDispatchCancelChukker,
  toggleIsChukkerEditedBannerVisible,
  updateMapState,
  toggleSideBar,
  toggleHideMenu,
  setTempLang
} = displayReducer.actions;
export default displayReducer.reducer;
